import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import Reveal from '../components/common/Reveal';
import { SectionHeader, Card, Tag, Pill } from '../components/ui';

export default function PoetsPage() {
  const [poets, setPoets] = useState([]);
  const [genres, setGenres] = useState([]);
  const [filter, setFilter] = useState('All');

  useEffect(() => { api.get('/poets/genres').then(r => setGenres(r.data)).catch(() => {}); }, []);
  useEffect(() => { api.get('/poets', { params: { genre: filter } }).then(r => setPoets(r.data)).catch(() => {}); }, [filter]);

  return (
    <div>
      <div style={{ padding: '120px 40px 40px', textAlign: 'center', background: 'linear-gradient(160deg,var(--cream),var(--soft-orange))' }}>
        <SectionHeader title="Punjabi" accent="Poets" sub="Greatest voices of Punjabi Sufi and literary tradition" />
      </div>
      <section style={{ padding: '40px 40px 80px', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', marginBottom: 32 }}>
          <Pill active={filter === 'All'} onClick={() => setFilter('All')}>All</Pill>
          {genres.map(g => <Pill key={g} active={filter === g} onClick={() => setFilter(g)}>{g}</Pill>)}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(340px,1fr))', gap: 24 }}>
          {poets.map((p, i) => (
            <Reveal key={p.id} delay={i * .07}>
              <Card style={{ padding: 24, display: 'flex', gap: 20 }}>
                <div style={{ width: 72, height: 72, borderRadius: 16, background: 'linear-gradient(135deg,var(--saffron),var(--gold))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem', flexShrink: 0, boxShadow: '0 4px 16px rgba(232,133,26,.25)' }}>{p.emoji}</div>
                <div style={{ flex: 1 }}>
                  <h3 className="serif" style={{ fontSize: '1.3rem', marginBottom: 2 }}>{p.name}</h3>
                  <p style={{ fontSize: 13, color: '#999', marginBottom: 4 }}>{p.era} · {p.genre}</p>
                  {p.bio && <p style={{ fontSize: 13, color: 'var(--brown)', fontWeight: 300, marginBottom: 8, lineHeight: 1.5 }}>{p.bio}</p>}
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {(p.works || []).map((w, j) => <Tag key={j} style={{ fontSize: 11 }}>{w}</Tag>)}
                  </div>
                </div>
              </Card>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
